export default __webpack_public_path__ + "static/media/information-banner.dbc34673.svg";